import React from "react";
import { Autocomplete, TextField, FormHelperText } from "@mui/material";

// Define the type for your options
interface UniversityOption {
  value: string | number;
  label?: string;
}

interface SearchSelectOptionsProps {
  options: UniversityOption[];
  label?: string;
  width?: number | string;
  value: string | number | null;
  onChange: (value: string | number | null) => void;
  isMandatory?: boolean;
  disabled?: boolean;
  helperText?: string;
  error?: boolean;
  setIsFormSaved?: any;
  isChangeUniversity?: boolean;
  handleChangeUniversity?: any;
  changeUniversityValue?: boolean;
}

const SearchSelectOptions: React.FC<SearchSelectOptionsProps> = ({
  options,
  label,
  value,
  onChange,
  isMandatory = false,
  disabled = false,
  helperText,
  error,
  setIsFormSaved,
  isChangeUniversity = false,
  handleChangeUniversity,
  changeUniversityValue,
}) => {
  return (
    <div style={{ width: "100%" }} className="form-container">
      {/* Label */}

      <div>
        <label
          htmlFor="custom-autocomplete"
          className="disbursement-inside-page-lable-condtion-dark"
          style={{
            color: error ? "red" : "#a5a3ae",
          }}
        >
          {label} {isMandatory && <span style={{ color: "red" }}>*</span>}
        </label>

        {isChangeUniversity && (
          <label
            htmlFor="custom-autocomplete"
            style={{
              fontSize: "11px",
              fontWeight: "400",
              color: "#FF9F43", // Fixed color code syntax
              lineHeight: "18px",
              cursor: "pointer",
            }}
            onClick={() => {
              handleChangeUniversity(changeUniversityValue ? false : true);
            }}
          >
            {"Change University"}
          </label>
        )}
      </div>

      {/* Autocomplete Component */}
      <Autocomplete
        id="custom-autocomplete"
        disabled={disabled}
        options={options}
        getOptionLabel={(option: any) => option?.label}
        fullWidth
        onChange={(event, newValue) => {
          setIsFormSaved?.(true);
          onChange(newValue ? newValue.value : null);
        }}
        value={options.find((option) => option.value === value) || null}
        renderInput={(params) => (
          <TextField
            {...params}
            error={error}
            fullWidth
            variant="outlined"
            disabled={disabled}
            sx={{
              textTransform: "capitalize !important",
              "& .MuiOutlinedInput-root": {
                borderRadius: "6px", // Border radius
                height: "38px", // Field height
                padding: "7px 14px 7px 14px", // Adjust inner padding
              },
              "& .MuiInputBase-input": {
                padding: "7px 14px 7px 0px !important", // Adjust inner padding
                fontSize: "11px",
                color: "#a5a3ae !important",
                fontWeight: "400",
              },
            }}
            className="custom-text-field"
          />
        )}
      />

      {/* Helper Text */}
      {helperText && (
        <FormHelperText
          error={error}
          style={{ marginTop: "4px", fontSize: "12px" }}
        >
          {helperText}
        </FormHelperText>
      )}
    </div>
  );
};

export default SearchSelectOptions;
